module.exports = __webpack_public_path__ + "static/media/image (38).186cb90a.jpg";